
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/ttblsportgmbh",
      function () {
        return require("private-next-pages/about/ttblsportgmbh/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/ttblsportgmbh"])
      });
    }
  